"use client";
import React from "react";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalClose.module.scss";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "../../CustomSVG/CustomSVG.client";

interface ModalCloseProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
}

export const ModalClose: React.FC<ModalCloseProps> = ({
  children,
  className = "",
  onClick,
  ...rest
}) => {
  const { open, setOpen } = useModal();
  const { getIcon, getLabel } = useGlobalContext();

  if (!open) return null;

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
    onClick?.(e);
  };

  return (
    <button
      type="button"
      {...rest}
      onClick={handleClose}
      className={`${styles["modal-close-btn"]} ${className}`.trim()}
    >
      {children ?? (
        <div className="is-flex is-gap-2 is-align-items-center">
          <CustomSVG
            src={getIcon("close")}
            className="is-flex"
            wrapper={"span"}
            width={16}
            height={16}
            aria-hidden="true"
          />
          <span>{getLabel("close", "Schließen")}</span>
        </div>
      )}
    </button>
  );
};
